/* eslint-disable no-constant-condition */
import {
  DataTablePrimeReact,
  Dialog,
  PaginationERP,
} from "@finanedi.es/storybook"
import { useQuery } from "@tanstack/react-query"
import { AmortizacionDtoProps } from "api/DTOs/AmortizacionDto"
import { AmortizacionReadingDtoProps } from "api/DTOs/AmortizacionReadingDto"
import { PrestamoDtoProps } from "api/DTOs/PrestamoDto"
import {
  GetAmortizacionesPrestamoByIdParamsProps,
  amortizacionesPrestamosByIdCall,
  deleteAmortizacionPrestamo,
  deletePrestamo,
  editAmortizaciones,
  editAnotationPrestamo,
  editPrestamo,
  getAmortizacionesPrestamosById,
  getPrestamoById,
  putAmortizaciones,
} from "api/Prestamos.service"
import DeleteModal from "common/components/Modal/DeleteModal"
import Modal from "common/components/Modal/Modal"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import notification from "common/utils/notification"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import ModalAsientoContable from "features/Contabilidad/components/ModalAsientoContable/ModalAsientoContable"
import { ModalNota } from "features/Tesoreria/pages/Bancos/pages/BancosDetail/components/ModalNota"
import { useDispatch } from "hooks/useDispatch"
import { useFilterMenu } from "hooks/useFilterMenu"
import { useCallback, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import DetailHeader from "../../components/DetailHeader"
import DetailSideInfo from "../../components/DetailSideInfo"
import NewAmortizacionForm from "../../components/NewAmortizacionForm"
import NewPrestamoForm from "../../components/NewPrestamoForm"
import { TYPE_DELETE_PRESTAMOS } from "../../constants"
import { FilterMenu } from "./FilterMenu"
import { PRESTAMO_DATAIL_COLUMNS } from "./Table/TableAmortizacionPrestamoColumns"
import TableAmortizacionesPrestamos from "./Table/TableAmortizacionPrestamos"
import { DeleteModalState, checkIfDateIsBefore } from "./constants"

const initialStateDeleteModal = {
  show: false,
  title: "",
  text: "",
  mode: null,
  id: null,
}

const PrestamoDetail = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const params = useParams()
  const [showModalAsiento, setShowModalAsiento] = useState(false)
  const [asientoSelectedEdit, setAsientoSelectedEdit] = useState<
    string | undefined
  >(undefined)
  const [openAmortizacionesModal, setOpenAmortizacionesModal] = useState(false)
  const [openAnnotationModal, setOpenAnnotationModal] = useState<{
    show: boolean
    data: AmortizacionReadingDtoProps | null
  }>({
    show: false,
    data: null,
  })
  const [showDelete, setShowDelete] = useState<DeleteModalState>(
    initialStateDeleteModal
  )
  const [showEditPrestamoModal, setShowEditPrestamoModal] =
    useState<boolean>(false)

  const {
    data: prestamoById,
    isLoading: prestamoByIdIsLoading,
    refetch: prestamoByIdRefetch,
  } = useQuery({
    queryKey: ["getPrestamoById", params?.id],
    queryFn: () =>
      params?.id ? getPrestamoById(params?.id) : Promise.resolve(null),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2, // 2 hours
    retry: false,
  })

  const pdfData = { id: params.id, concepto: prestamoById?.concepto }

  const fetchItems = useCallback(() => {
    return async (queryParams: GetAmortizacionesPrestamoByIdParamsProps) => {
      if (params?.id && !!queryParams) {
        const resp = await getAmortizacionesPrestamosById(
          params?.id,
          queryParams
        )
        amortizacionesPrestamosByIdCall.cancel()
        return resp
      }
      return null
    }
  }, [params?.id])

  const { items, isLoading, setServiceQuery, fetchTableData } = useFilterMenu({
    serviceCall: fetchItems,
  })

  const dtRef = useRef<DataTablePrimeReact<AmortizacionReadingDtoProps[]>>(null)
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })
  const totalItems = items ?? []
  const paginatedItems = totalItems.slice(
    pagination.skipCount,
    pagination.skipCount + pagination.itemsPerPage
  )

  const handleRedirectToList = () => {
    history.push(ROUTES.PRESTAMOS)
  }

  const handelDeletePrestamo = async () => {
    const { status }: { status: number } = await deletePrestamo(
      params?.id as string
    )

    if (status === STATUSCORRECT) {
      history.push(ROUTES.PRESTAMOS)
      notification.success({
        body: `${t("filtros.prestamo.message.sucess.deletePrestamo")}`,
      })
    }
  }
  const handleDeleteAmortizacionPrestamo = async () => {
    const { status }: { status: number } = await deleteAmortizacionPrestamo({
      PrestamoId: params?.id as string,
      AmortizacionId: showDelete?.id as string,
    })
    if (status === STATUSCORRECT) {
      fetchTableData()
      setShowDelete(initialStateDeleteModal)
      notification.success({
        body: `${t("filtros.prestamo.message.sucess.deleteAmortizacion")}`,
      })
    }
  }

  const handleEditPrestamo = async (values: PrestamoDtoProps) => {
    const { status }: { status: number } = await editPrestamo({
      data: values,
      id: params.id as string,
    })
    if (status === STATUSCORRECT) {
      fetchTableData()
      prestamoByIdRefetch()
      setShowEditPrestamoModal(false)
      notification.success({
        body: `${t("filtros.prestamo.message.sucess.editPrestamo")}`,
      })
    }
  }

  const handleAnnotation = async (values: { descripcion: string }) => {
    const body = JSON.stringify(values.descripcion)
    const { status }: { status: number } = await editAnotationPrestamo({
      prestamoId: params?.id as string,
      amortizacionId: openAnnotationModal.data?.id as string,
      body,
    })
    if (status === STATUSCORRECT) {
      fetchTableData()
      setOpenAnnotationModal((preValue) => ({
        ...preValue,
        show: false,
      }))
      notification.success({
        body: `${t("filtros.prestamo.message.sucess.editAmortizacion")}`,
      })
    }
  }

  const handleEditAmortizacion = async (
    amortizacionId: string,
    isChecked: boolean
  ) => {
    const { status }: { status: number } = await editAmortizaciones({
      prestamoId: params.id as string,
      amortizacionId,
      asientoContableStatus: isChecked,
    })
    if (status === STATUSCORRECT) {
      prestamoByIdRefetch()
      fetchTableData()
      notification.success({
        body: `${t("filtros.prestamo.message.sucess.editAmortizacion")}`,
      })
    }
  }

  const handleCreateAmortizacion = async (values: AmortizacionDtoProps) => {
    const { status }: { status: number } = await putAmortizaciones({
      data: values,
      prestamoId: params.id as string,
    })
    if (status === STATUSCORRECT) {
      prestamoByIdRefetch()
      setOpenAmortizacionesModal(!openAmortizacionesModal)
      fetchTableData()
      notification.success({
        body: `${t("filtros.prestamo.message.sucess.createAmortizacion")}`,
      })
    }
  }

  const handleOpenAnnotationModal = (rowData: AmortizacionReadingDtoProps) => {
    setOpenAnnotationModal({
      show: !openAnnotationModal.show,
      data: rowData,
    })
  }

  const handleOpenAmortizacionesModal = () => {
    setOpenAmortizacionesModal(!openAmortizacionesModal)
  }

  const handleOpenModalPrestamo = (data: AmortizacionReadingDtoProps) => {
    if (data.asientoContable) {
      setShowModalAsiento(true)
      setAsientoSelectedEdit(data?.asientoContable?.id)
    }
  }

  const isNewAmortizacionesDisabled = Boolean(
    !(items as AmortizacionReadingDtoProps[])[0]?.asientoContable
  )
  const isUnpaid = Boolean(
    (items as AmortizacionReadingDtoProps[])?.find((amortizacion) => {
      return checkIfDateIsBefore(amortizacion) && !amortizacion?.asientoContable
    })
  )

  return (
    <>
      <div className='tw-w-full tw-h-full tw-overflow-y-hidden'>
        <div className='tw-flex tw-flex-row tw-gap-x-6 tw-p-6 tw-h-full'>
          <div className='tw-w-4/5 tw-h-full'>
            <DetailHeader
              handleRedirectToList={handleRedirectToList}
              handleDelete={() =>
                setShowDelete({
                  show: true,
                  title: `${t("prestamos.idView.deleteButton")}${t(
                    "prestamos.idView.deleteTitle"
                  )}`,
                  text: `${t("prestamos.idView.deleteText")}`,
                  mode: TYPE_DELETE_PRESTAMOS.prestamos,
                  id: null,
                })
              }
              handleEdit={() => {
                setShowEditPrestamoModal(true)
              }}
              prestamo={prestamoById}
              handleOpenAmortizacionesModal={handleOpenAmortizacionesModal}
              isNewAmortizacionesDisabled={isNewAmortizacionesDisabled}
              pdfData={pdfData}
            />
            {prestamoById && (
              <div className='tw-h-[calc(100%-72px)]'>
                <FilterMenu
                  serviceQuery={setServiceQuery}
                  prestamoById={prestamoById.fecha}
                />
                <div className='tw-flex tw-flex-col tw-relative tw-h-[calc(100%-86px)] tw-bg-white'>
                  <div className='tw-h-[calc(100%-60px)] tw-min-h-0 tw-overflow-x-auto'>
                    <TableAmortizacionesPrestamos
                      items={paginatedItems}
                      isLoading={isLoading}
                      prestamoByIdIsLoading={prestamoByIdIsLoading}
                      columns={PRESTAMO_DATAIL_COLUMNS(
                        t,
                        items as AmortizacionReadingDtoProps[],
                        {
                          handleOpenAnnotationModal,
                          handleEditAmortizacion,
                          handleOpenModalPrestamo,
                          setShowDelete,
                        }
                      )}
                    />
                  </div>
                  <PaginationERP
                    className={PAGINATION_STYLES}
                    totalRecords={items.length}
                    first={pagination.skipCount}
                    rows={pagination.itemsPerPage}
                    resetScroll={() =>
                      dtRef.current && dtRef.current?.resetScroll()
                    }
                    setPagination={setPagination}
                    optionDropdown={[10, 20, 50, 100]}
                    texts={{
                      textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
                      textCurrentPageReport: `${t("pagination.from")}`,
                    }}
                  />
                </div>
              </div>
            )}
          </div>
          <aside className='tw-w-1/5'>
            <DetailSideInfo prestamo={prestamoById} />
          </aside>
        </div>
      </div>
      <DeleteModal
        visible={showDelete?.show}
        onHide={() => setShowDelete(initialStateDeleteModal)}
        size='small'
        iconType='remesas'
        buttonLabel={t("prestamos.idView.confirmButton")}
        title={showDelete.title}
        message={showDelete?.text}
        onConfirm={
          showDelete.mode === TYPE_DELETE_PRESTAMOS.prestamos
            ? handelDeletePrestamo
            : handleDeleteAmortizacionPrestamo
        }
      />
      <ModalNota
        isOpen={openAnnotationModal.show}
        onHide={() =>
          setOpenAnnotationModal({
            show: false,
            data: null,
          })
        }
        data={openAnnotationModal.data}
        handleSubmitAnnotation={handleAnnotation}
      />

      <Dialog
        header={
          prestamoById
            ? t("prestamos.idView.editTitle")
            : t("prestamos.idView.createTitle")
        }
        visible={showEditPrestamoModal}
        onHide={() => {
          setShowEditPrestamoModal(false)
        }}
        maskClassName='!tw-p-6'
        baseZIndex={30}
        className='departaments-modal !tw-w-180'
        draggable
      >
        <NewPrestamoForm
          // @ts-expect-error TS(2322): Type '{ hideModal: () => void; dispatch: Dispatch<...
          hideModal={() => {
            setShowEditPrestamoModal(false)
          }}
          dispatch={dispatch}
          onHide={() => {
            setShowEditPrestamoModal(false)
          }}
          hideModalPrincipal={() => {
            setShowEditPrestamoModal(false)
          }}
          handleSubmitPrestamo={handleEditPrestamo}
          deuda={prestamoById?.deuda && prestamoById.deuda > 0}
          data={prestamoById}
          dataPrestamo={items}
          isEditView
          t={t}
          newPrestamo={!prestamoById}
        />
      </Dialog>

      <Modal
        header={t("prestamos.idView.newRedemption")}
        visible={openAmortizacionesModal}
        onHide={handleOpenAmortizacionesModal}
        size='small'
        maskClassName='!tw-z-20'
        className='departaments-modal nueva-comision'
        draggable
      >
        <NewAmortizacionForm
          // @ts-expect-error TS(2322): Type '{ handleOpenModal: () => void; prestamo: Pre...
          handleOpenModal={handleOpenAmortizacionesModal}
          prestamo={prestamoById}
          isUnpaid={isUnpaid}
          createAmortizacion={handleCreateAmortizacion}
          t={t}
        />
      </Modal>

      <ModalAsientoContable
        idToEdit={asientoSelectedEdit}
        show={showModalAsiento}
        setShow={setShowModalAsiento}
        updateTable={fetchTableData}
      />
    </>
  )
}

export default PrestamoDetail
